import { useEffect, useRef } from 'react'

const useSignInHandler = () => {
  const reloadRequestedRef = useRef(false)
  useEffect(() => {
    if (window.location.pathname === '/sign-in' && !reloadRequestedRef.current) {
      reloadRequestedRef.current = true
      window.location.reload()
    }
    // eslint-disable-next-line
  }, [window.location.pathname])
}

export default useSignInHandler
